import { AppStorage } from "@bbwt/utils/app-storage";
import { IEpisode } from "@project/models/episodes/episode";
import { Note } from "@project/models/notes/note";
import { WalkIn } from "./walk-in";

export class WalkInOfflineStorage {
    private static readonly cacheKey = "api/walk-ins";

    static get(id: string): WalkIn {
        return this.correctDateTime(AppStorage.getOfflineEntity<WalkIn>(id, this.cacheKey));
    }

    static remove(id: string): WalkIn {
        return this.correctDateTime(AppStorage.extractOfflineEntity<WalkIn>(id, this.cacheKey));
    }

    static save(walkIn: WalkIn): WalkIn {
        return this.correctDateTime(AppStorage.setOfflineEntity<WalkIn>(this.cacheKey, walkIn));
    }

    static getAll(): WalkIn[] {
        return AppStorage.getOfflineEntities<WalkIn>(this.cacheKey).map(walkIn => this.correctDateTime(walkIn));
    }

    static update(walkIn: WalkIn): WalkIn {
        return this.correctDateTime(AppStorage.replaceOfflineEntity(walkIn, this.cacheKey));
    }

    static updateEpisode(episodeId: string, episode: IEpisode): void {
        const walkins: WalkIn[] = this.getAll().filter(w => w.episodeId == episodeId);

        walkins.forEach(w => {
            this.update({ ...w, episodeId: episode.id, episode });
        });
    }

    static updatePatientId(oldPatientId: string, patientId: string) {
        var patientWalkIns = this.getAll()
            .filter(w => w.patientId == oldPatientId)
            .map(walkIn => ({ ...walkIn, patientId }));
        patientWalkIns.forEach(w => this.update(w));
    }

    static addNote(walkInId: string, note: Note): void {
        const walkIn = this.get(walkInId);
        if (walkIn != null) {
            walkIn.notes = [...(walkIn.notes ?? []), note];
            this.update(walkIn);
        }
    }

    static removeNote(walkInId: string, noteId: string): void {
        const walkIn = this.get(walkInId);
        if (walkIn != null) {
            var index = walkIn.notes.findIndex(n => n.id === noteId);
            walkIn.notes.splice(index, 1);
            this.update(walkIn);
        }
    }

    static updateNote(walkInId: string, note: Note): void {
        const walkIn = this.get(walkInId);
        if (walkIn != null) {
            var index = walkIn.notes.findIndex(n => n.id === note.id);
            walkIn.notes[index] = note;
            this.update(walkIn);
        }
    }

    private static correctDateTime(walkin: WalkIn): WalkIn {
        return walkin?.createDateTime ? { ...walkin, createDateTime: new Date(walkin.createDateTime) } : walkin;
    }
}
